import React from 'react';
import './css/NavMenu.css';
import Menu from "./Menu"
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useLocation } from "react-router-dom"
import packageJson from '../../package.json';
import { getCookie } from "./Action/HandleCookie"
import Grid from '@mui/material/Grid';

export default function NavMenu() {
    const Location = useLocation();
    const [pageName, setPageName] = React.useState("");
    const [userName, setuserName] = React.useState("");
    const [shozokuName, setShozokuName] = React.useState("");
    const isStaging = window.location.href.includes("hubdb2");

    React.useLayoutEffect(() => {
        setuserName(getCookie("userName"))
        setShozokuName(getCookie("userShitenName") + " " + getCookie("userShozokuName"))
        if (Location.pathname === "/" || Location.pathname.toLowerCase() === "/omsuser" || Location.pathname.toLowerCase() === "/vender") {
            setPageName("")
            setuserName("")
            setShozokuName("")
        }
        else if (Location.pathname === "/top") { setPageName("業務選択") }
        else if (Location.pathname === "/digitalconstract/list") { setPageName("請負契約書一覧") }
        else if (Location.pathname === "/digitalconstract") { setPageName("請負契約書") }
        else if (Location.pathname === "/digitalconstract/customerconfirm") { setPageName("請負契約書 ご署名") }
        else if (Location.pathname === "/inspection") { setPageName("お客様点検記録メニュー") }
        else if (Location.pathname === "/inspection/shorttermWarranty/list") { setPageName("お客様点検記録(短期保証)一覧") }
        else if (Location.pathname === "/inspection/longtermWarranty/list") { setPageName("お客様点検記録(長期保証)一覧") }
        else if (Location.pathname === "/inspection/accountManagement/list") { setPageName("請負担当者アカウント管理") }
        else if (Location.pathname === "/inspection/propertyAssignment/list") { setPageName("請負担当者物件割り当て") }
        else if (Location.pathname === "/inspection/visitReport/customerlist") { setPageName("訪問記録お客様一覧画面") }
        else if (Location.pathname === "/inspection/visitReport/customerlist/reportlist") { setPageName("訪問記録一覧画面") }

        else {
            setPageName("")
        }

    }, [Location.pathname]);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" color={isStaging ? "success" : "primary"}>
                <Toolbar >
                    {Location.pathname !== "/" && Location.pathname.toLowerCase() !== "/omsuser" && Location.pathname.toLowerCase() !== "/vender" ?
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ transform: "scale(1.5)", mt: 1 }}
                        >
                            <Menu />
                        </IconButton>
                        : null
                    }
                    <img src={`${process.env.PUBLIC_URL}/Logo/logo.png`} alt="logo" />
                    <Typography variant="h5" component="div" sx={{ pl: 3, flexGrow: 2.5 }}>
                        電子サイン{isStaging ? " Staging環境" : ""}
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ flexGrow: 3.5 }} >
                        {pageName}
                    </Typography>
                    <Typography variant="caption" component="div">
                        <Grid container justifyContent="end">
                            <Grid item xs={12}>
                                <Typography variant="caption" component="div" >
                                    {shozokuName ? shozokuName : null}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption" component="div" >
                                    {userName ? userName : null}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Typography>
                    <Typography variant="caption" component="div" style={{ textAlign: 'right' }}>
                        Ver{packageJson.version}
                    </Typography>
                </Toolbar>
            </AppBar>
            {(localStorage.getItem("loginType") !== '0' && (Location.pathname !== "/" && Location.pathname.toLowerCase() !== "/omsuser" && Location.pathname.toLowerCase() !== "/vender")) ?
                null
                :
                < Grid sx={{ height: 64 }} />
            }
        </Box >
    );
}